'use client'
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react'

export interface LoadMoreSectionProps {
  fetchNextPage: () => void
  hasNextPage: boolean
  isFetchingNextPage: boolean
  isLoading: boolean
}

export const LoadMoreSection = ({
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  isLoading,
}: LoadMoreSectionProps) => {
  const { ref, inView } = useInView()

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage && !isLoading) {
      fetchNextPage()
    }
  }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading])

  return (
    <div ref={ref} className='h-4 w-full'>
      {isFetchingNextPage && (
        <div className='flex justify-center items-center py-4'>
          <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-primary-surface-100'></div>
        </div>
      )}
    </div>
  )
}
